module.exports = __webpack_public_path__ + "img/pin_1.d68dffe3.svg";